var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakerphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 47,
    viewBox: "0 0 99 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.0713 25.8501C98.0713 37.5309 76.2104 47.0001 49.2436 47.0001C22.2769 47.0001 0.416016 37.5309 0.416016 25.8501C0.416016 14.1693 22.2769 4.7002 49.2436 4.7002C76.2104 4.7002 98.0713 14.1693 98.0713 25.8501Z",
    fill: "url(#paint0_linear_2_32181)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0713 21.1499C98.0713 32.8307 76.2104 42.2999 49.2436 42.2999C22.2769 42.2999 0.416016 32.8307 0.416016 21.1499C0.416016 9.46915 22.2769 0 49.2436 0C76.2104 0 98.0713 9.46915 98.0713 21.1499Z",
    fill: "url(#paint1_linear_2_32181)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1476 20.5627C85.1476 29.3232 69.3949 36.4251 49.9629 36.4251C30.531 36.4251 14.7783 29.3232 14.7783 20.5627C14.7783 11.8021 30.531 4.7002 49.9629 4.7002C69.3949 4.7002 85.1476 11.8021 85.1476 20.5627Z",
    fill: "url(#paint2_linear_2_32181)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1476 19.3869C85.1476 28.1475 69.3949 35.2493 49.9629 35.2493C30.531 35.2493 14.7783 28.1475 14.7783 19.3869C14.7783 10.6263 30.531 3.52441 49.9629 3.52441C69.3949 3.52441 85.1476 10.6263 85.1476 19.3869Z",
    fill: "url(#paint3_linear_2_32181)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0981 35.0668C91.7529 31.3179 96.6352 26.3406 96.6352 21.1499C96.6352 15.9592 91.7529 10.982 83.0981 7.23312C74.5075 3.51208 62.5406 1.175 49.2436 1.175C35.9467 1.175 23.9798 3.51208 15.3892 7.23312C6.73443 10.982 1.85212 15.9592 1.85212 21.1499C1.85212 26.3406 6.73443 31.3179 15.3892 35.0668C23.9798 38.7878 35.9467 41.1249 49.2436 41.1249C62.5406 41.1249 74.5075 38.7878 83.0981 35.0668ZM49.2436 42.2999C76.2104 42.2999 98.0713 32.8307 98.0713 21.1499C98.0713 9.46915 76.2104 0 49.2436 0C22.2769 0 0.416016 9.46915 0.416016 21.1499C0.416016 32.8307 22.2769 42.2999 49.2436 42.2999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2442 39.3621C49.6408 39.3621 49.9623 39.0991 49.9623 38.7746C49.9623 38.4501 49.6408 38.1871 49.2442 38.1871C48.8476 38.1871 48.5262 38.4501 48.5262 38.7746C48.5262 39.0991 48.8476 39.3621 49.2442 39.3621ZM49.2442 39.9496C50.0374 39.9496 50.6803 39.4235 50.6803 38.7746C50.6803 38.1257 50.0374 37.5996 49.2442 37.5996C48.4511 37.5996 47.8081 38.1257 47.8081 38.7746C47.8081 39.4235 48.4511 39.9496 49.2442 39.9496Z",
    fill: "#B4B4B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8912 20.5623C91.2878 20.5623 91.6092 20.2993 91.6092 19.9748C91.6092 19.6503 91.2878 19.3873 90.8912 19.3873C90.4946 19.3873 90.1731 19.6503 90.1731 19.9748C90.1731 20.2993 90.4946 20.5623 90.8912 20.5623ZM90.8912 21.1498C91.6843 21.1498 92.3273 20.6237 92.3273 19.9748C92.3273 19.3259 91.6843 18.7998 90.8912 18.7998C90.098 18.7998 89.4551 19.3259 89.4551 19.9748C89.4551 20.6237 90.098 21.1498 90.8912 21.1498Z",
    fill: "#B4B4B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03327 20.5623C9.42984 20.5623 9.75133 20.2993 9.75133 19.9748C9.75133 19.6503 9.42984 19.3873 9.03327 19.3873C8.6367 19.3873 8.31522 19.6503 8.31522 19.9748C8.31522 20.2993 8.6367 20.5623 9.03327 20.5623ZM9.03327 21.1498C9.82641 21.1498 10.4694 20.6237 10.4694 19.9748C10.4694 19.3259 9.82641 18.7998 9.03327 18.7998C8.24013 18.7998 7.59717 19.3259 7.59717 19.9748C7.59717 20.6237 8.24013 21.1498 9.03327 21.1498Z",
    fill: "#B4B4B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2442 2.9373C49.6408 2.9373 49.9623 2.67427 49.9623 2.3498C49.9623 2.02534 49.6408 1.7623 49.2442 1.7623C48.8476 1.7623 48.5262 2.02534 48.5262 2.3498C48.5262 2.67427 48.8476 2.9373 49.2442 2.9373ZM49.2442 3.5248C50.0374 3.5248 50.6803 2.99873 50.6803 2.3498C50.6803 1.70087 50.0374 1.1748 49.2442 1.1748C48.4511 1.1748 47.8081 1.70087 47.8081 2.3498C47.8081 2.99873 48.4511 3.5248 49.2442 3.5248Z",
    fill: "#B4B4B4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_32181",
    x1: 49.2436,
    y1: 4.7002,
    x2: 49.2436,
    y2: 47.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32302F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_32181",
    x1: 49.2436,
    y1: 0,
    x2: 49.2436,
    y2: 42.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32302F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54504E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_32181",
    x1: 19.0866,
    y1: 20.5627,
    x2: 85.0861,
    y2: 24.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7886FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_32181",
    x1: 49.9629,
    y1: 3.52441,
    x2: 49.9629,
    y2: 35.2493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23211F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F3D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerphone);
export default __webpack_public_path__ + "static/media/Speakerphone.3f091afde6279d7a8605d6ff4287308e.svg";
export { ForwardRef as ReactComponent };